// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */

import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import type {Profile, ProfilePageDispatchProps, ProfilePageStateProps} from "../../components/profile/ProfilePage";
import ProfilePage from "../../components/profile/ProfilePage";
import {profileUpdateAction} from "../../actions/profile/creators/profileUpdateActionCreator";

const mapStateToProps = (state: StoreState): ProfilePageStateProps => {

    return {};
};

const mapDispatchToProps = (dispatch): ProfilePageDispatchProps => {
    return {
        onSubmit: (profile: Profile) => {
            dispatch(profileUpdateAction(profile));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);



// WEBPACK FOOTER //
// ./src/containers/profile/ProfilePage.js